'use client';

import { usePathname } from 'next/navigation';
import Footer from '@/components/layout/Footer';
const HIDDEN_PATHS = ['/auth'];

export default function FooterWrapper() {
  const pathname = usePathname();
  if (HIDDEN_PATHS.includes(pathname)) {
    return null;
  }
  return <Footer />;
}
